<template>
  <div class="notSign-container">
    <div class="top-tip">
      <!-- v-if="!currentSignInfo[0].changeBenefit" -->
      <div
        class="top-tip-content"
      >
        您好，老板，请您确认美团充电宝入驻门店的机柜信息，<b>若信息无误，请及时确认。</b>
      </div>
      <!-- <div
        v-else
        class="top-tip-content"
      >
        您的门店分润比例需调整，请尽快确认如下信息。
      </div> -->
    </div>
    <!-- v-if="!currentSignInfo[0].changeBenefit" -->
    <div
      class="info-card"
    >
      <div class="title">
        分成信息
      </div>
      <div class="row">
        <div class="left">
          收款账号
        </div>
        <div class="right">
          钱袋宝{{ currentSignInfo[0] && currentSignInfo[0].walletId | idFilter }}
        </div>
      </div>
      <div
        v-if="!isAgent"
        class="row"
      >
        <div class="left">
          发票说明
        </div>
        <div class="right">
          {{ currentSignInfo[0] && currentSignInfo[0].invoiceDesc }}
        </div>
      </div>
    </div>
    <div class="lists-title">
      门店列表
    </div>
    <van-list
      v-model="isLoading"
      :finished="isFinish"
      :error.sync="isError"
      :error-text="errorText"
      :finished-text="finishedText"
      @load="request()"
    >
      <div
        v-for="(item, idx) in currentSignInfo"
        :key="idx"
        class="info-card"
      >
        <div class="title">
          {{ item.poiName }}
        </div>
        <div class="row">
          <div
            class="row-item"
            :class="{ 'right-border': item.changeBenefit }"
          >
            <span
              v-if="!item.changeBenefit"
              class="left"
            >分润比例</span>
            <span
              v-else
              class="left"
            >原分润比例</span>
            <span class="right bold">{{ item.benefitRate }}%</span>
          </div>
          <div
            v-if="item.changeBenefit"
            class="row-item"
          >
            <span class="left">新分润比例</span>
            <span class="right red bold">{{ item.applyChangeBenefitRate }}%</span>
          </div>
        </div>
        <div class="row">
          <div class="row-item right-border">
            <span class="left">机柜数量</span>
            <span class="right">{{ item.cabinetCount }}台</span>
          </div>
          <div class="row-item">
            <span class="left">成本摊销</span>
            <span class="right">{{ item.ka ? item.existCost ? '需摊销' : '无需摊销' : '--' }}</span>
          </div>
        </div>
        <div class="row">
          <div class="row-item">
            <span class="left">申请调整时间</span>
            <span class="right">{{ item.applyChangeTime }}</span>
          </div>
        </div>
      </div>
    </van-list>
    <div class="bottom-btns">
      <van-button
        type="default"
        class="close-btn"
        :data-bid="$BID.NOT_SIGN_CLOSE"
        @click="close"
      >
        稍后签约
      </van-button>
      <van-button
        :disabled="submiting"
        type="primary"
        class="confirm-btn"
        :data-bid="$BID.NOT_SIGN_CONFIRM"
        @click="sign"
      >
        已阅读并确认
      </van-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Contract from '@/api/contract';
import STATUS from '@/constants/status';
import Store from '@/store/index';

export default {
  name: 'NotSign',
  filters: {
    idFilter(val) {
      if (!val || val === '0') {
        val = '--';
      }
      return val;
    },
  },
  data() {
    return {
      list: [],
      isLoading: false,
      isFinish: false,
      finishedText: '没有更多了~',
      errorText: '数据量过多，请点击刷新重试',
      isError: false,
      nextKey: '0',
      index: 0, // 待签约signInfo序号
      submiting: false,
    };
  },
  computed: {
    ...mapState(['isAgent', 'signInfo']),
    currentSignInfo() {
      return this.list.length ? this.list : this.signInfo;
    },
  },
  created() {
    document.title = '待确认签约信息';
  },
  methods: {
    async request() {
      if (!this.isFinish) {
        try {
          this.isLoading = true;
          const res = await Store.dispatch('fetchNotSignContracts', { nextKey: this.nextKey });// https://km.sankuai.com/collabpage/2730792279
          this.nextKey = res.nextKey;
          if (!res.hasNext) {
            this.isFinish = true;
          }
          if (res.contractInfoList) {
            this.list = this.list.concat(res.contractInfoList);
          }
          if (res.hasNext && !res.contractInfoList) { // 可能存在有数据，但是当前遍历不返回数据的情况（数据量太大，涉及多项目联表），这种默认给提示去联系bd。
            this.isFinish = true;
            // this.submiting = true;//禁用按钮
            this.$dialog.toast('门店信息太多无法展示，请联系BD确定签约');
          }
          this.isError = false;
        } catch (error) {
          console.error(error);
          this.isError = true;
        } finally {
          this.isLoading = false;
        }
      }
    },
    /**
     * 签约
     */
    async sign() {
      this.submiting = true;
      this.$dialog.loading.show();

      await Contract.batchSignContract().then((res) => {
        this.submiting = false;
        this.$dialog.loading.hide();
        // 签约成功
        if (res.respCode === STATUS.SUCCESS) {
          Store.commit('setSignInfo', []);// 重置签约信息
          this.close();
        } else {
          this.$dialog.toast(res.respMsg || '签约失败');
        }
      }).catch(() => {
        this.submiting = false;
        this.$dialog.loading.hide();
        this.$dialog.toast('签约失败');
      });
    },
    /**
     * 签约-关闭页面
     * 分润调整-跳转首页
     */
    close() {
      sessionStorage.setItem('NotSignPopClosed', 'true');
      this.$router.replace({
        path: '/',
      });
      // if (!this.$isWXApplet) {
      //   this.KNB.closeWebview();
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.notSign-container {
  padding-bottom: 170px;
  text-align: left;
  .top-tip {
    padding: 30px;
    background: #FFF;
    margin-bottom: 18px;
    .top-tip-content {
      background: #FFFAE0;
      color: #C28100;
      padding: 21px 30px;
      text-align: left;
      border-radius: 12px;
      font-size: 26px;
      line-height: 37px;
      b {
        font-weight: bold;
      }
    }
  }
  .info-card {
    margin: 24px;
    padding: 30px;
    border-radius: 24px;
    background: #FFF;
    .title {
      color: #111111;
      font-family: PingFang SC;
      font-weight: 600;
      font-size: 32px;
      line-height: 44px;
      text-align: left;
      letter-spacing: 0;
    }
    .row {
      display: flex;
      margin-top: 12px;
      .row-item{
        padding: 0 12px;
        line-height: 32px;
        height: 32px;
        .left{
          margin-right: 12px;
        }
      }
      .right-border{
        border-right:  1px solid #e5e5e5;
      }
      .left {
        width: 106px;
        margin-right: 24px;
        font-weight: 400;
        color: #888888;
        font-family: PingFang SC;
        font-size: 24px;
        line-height: 32px;
        text-align: left;
      }
      .right {
        flex: 1;
        font-weight: 400;
        color: #111111;
        font-family: PingFang SC;
        font-size: 24px;
        line-height: 32px;
        text-align: left;
        &.bold{
          font-weight: 600;
        }
        &.red{
          color: #FF5500;
        }
      }
    }
  }
  .lists-title{
    margin-top: 30px;
    color: #888888;
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    text-align: left;
    margin-left: 24px;
  }
  .tips {
    margin: 0 48px;
    font-size: 24px;
  }
  .sign-table {
    margin-top: 24px;
  }
  .bottom-btns {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    padding: 24px;
    z-index: 10;
    background: #FFF;
    .van-button {
      border-radius: 0.12rem;
      font-weight: 500;
      color: #222222;
      &.close-btn{
        background: #fff;
      }
      &.confirm-btn{
        background: #FFD100;
        border-color: #FFD100;
      }
      flex: 1;
      &:first-child {
        margin-right: 24px;
      }
    }
  }

}
</style>
